export interface Testimonial {
  text: string
  author: string
  role: string
  location: string
}

export const testimonials: Testimonial[] = [
  {
    text: 'Faccio l’elettricista da quindici anni e i clienti mi chiedevano sempre più spesso luci smart, termostati e telecamere. Dicevo no perché non conoscevo gli ecosistemi e avevo paura di consegnare un impianto che poi non funzionava. Il modulo sui protocolli e quello sulla progettazione mi hanno dato finalmente un metodo: analizzo la casa, definisco le zone, scelgo i dispositivi compatibili e solo dopo configuro. Ho chiuso il mio primo impianto completo in un appartamento di ottanta metri e il cliente mi ha già presentato a suo fratello.',
    author: 'Marco Ricci',
    role: 'Elettricista, 42 anni',
    location: 'Brescia',
  },
  {
    text: 'Sono partito da zero, solo con un paio di prese smart comprate online e molta confusione. Avevo Alexa, un sensore Zigbee senza hub e tre app diverse che non parlavano tra loro. Seguendo i moduli in ordine ho capito cosa mi mancava e ho rifatto tutto con criterio. Oggi la casa ha illuminazione, clima e allarme che lavorano insieme e le automazioni partono da sole. La checklist di test è la cosa che ho usato di più.',
    author: 'Andrea Bellini',
    role: 'Impiegato tecnico e appassionato di tecnologia, 34 anni',
    location: 'Bologna',
  },
  {
    text: 'Installo antifurti e videosorveglianza, quindi la parte di cablaggio la conoscevo bene. Quello che mi mancava era la logica delle automazioni e l’integrazione tra ecosistemi. Il modulo sugli scenari e il vault dei casi pronti mi hanno permesso di proporre ai clienti pacchetti che prima non sapevo nemmeno spiegare. Il valore medio dei miei preventivi è cresciuto in modo netto in due mesi.',
    author: 'Giuseppe Lombardi',
    role: 'Installatore di sistemi di sicurezza, 47 anni',
    location: 'Torino',
  },
  {
    text: 'Il pezzo che mi ha salvato è il Troubleshooting Lab. Prima, quando un sensore usciva dalla rete, perdevo pomeriggi interi a provare a caso e davanti al cliente facevo una figura terribile. Adesso seguo la sequenza diagnostica e nella maggior parte dei casi trovo il problema in pochi minuti. Anche la documentazione finale di consegna ha cambiato il modo in cui i clienti percepiscono il mio lavoro.',
    author: 'Stefano Conti',
    role: 'Tecnico termoidraulico in ampliamento verso la domotica, 51 anni',
    location: 'Verona',
  },
  {
    text: 'Avevo ristrutturato casa e volevo gestire tutto da un unico punto senza dipendere da un installatore per ogni modifica. La parte su Matter, Thread e Home Assistant è spiegata in modo comprensibile anche per chi non è del settore. Ho progettato l’impianto stanza per stanza seguendo le schede del bonus e in tre settimane avevo luci, tapparelle, clima e accessi funzionanti. Mia moglie usa solo le routine e non ha mai chiesto assistenza.',
    author: 'Davide Parisi',
    role: 'Libero professionista e DIY, 38 anni',
    location: 'Roma',
  },
]
